module.exports = __webpack_public_path__ + "img/logo.0ae56136.svg";